
import { computed, defineComponent, PropType } from 'vue'
import { isUxMdiIcon, isUxSvgIcon, UxIcon } from '@/helpers/marketplace/uxSettings'

export default defineComponent({
    name: 'UxIcon',
    props: {
        icon: {
            type: [String, Object] as PropType<UxIcon | null>,
            default: '',
        },
    },
    setup(props) {
        const svg = computed(() => (isUxSvgIcon(props.icon) ? props.icon.svg : ''))
        const mdi = computed(() => (isUxMdiIcon(props.icon) ? props.icon.mdi : ''))
        const label = computed(() => (typeof props.icon === 'string' ? props.icon : ''))
        return { svg, mdi, label }
    },
})
